// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"d0c7276e","85":"f29ed822","132":"13118a50","418":"8d4f41ec","489":"02eb0098","908":"9d1b5fb5"}[chunkId] + ".chunk.js";
};